import React from "react";
import { ChangeEvent, FormEvent } from "react";
import { Redirect } from "react-router";
import { RouteComponentPropsHistory } from "./types";

import { History } from "history";

import { IS_PRE_RELEASE, VERSION, VERSION_BUILD } from "./version";

import { IAuthProps } from "./components/AuthContext";
import withAuth from "./components/withAuth";

import "./blocks.css";
import "./button.css";
import "./form.css";
import "./LoginPage.css";

import HCWHLogo from "./images/hcwh_logo_small.png";
import OverflowMenuItem from "./components/OverflowMenuItem";
import ToolbarMenuItem from "./components/ToolbarMenuItem";

interface ILoginPageState {
    username: string;
    password: string;
    response: any;
    isPending: boolean;
    error?: string;

    postLoginTarget: History.LocationDescriptor<any>;

    serverTarget: string;

    [name: string]: string | any;
}

class LoginPage extends React.Component<IAuthProps & RouteComponentPropsHistory<any, any>, ILoginPageState> {
    constructor(props: Readonly<IAuthProps & RouteComponentPropsHistory<any, any>>) {
        super(props);

        let ref = this.props.location.state && this.props.location.state.referer;
        if (ref && ((typeof ref === "string" && ref === "/login") || (ref.pathname && ref.pathname === "/login"))) {
            ref = undefined; // Don't send back to login page
        }

        this.state = {
            isPending: false,
            password: "",
            response: "",
            username: "",

            error: "",

            postLoginTarget: ref ? ref : { pathname: "/dashboard" },

            serverTarget: props.authContext.authTarget,
        };

        this.processLogin = this.processLogin.bind(this);
        this.formChanged = this.formChanged.bind(this);
        this.switchToPlayground = this.switchToPlayground.bind(this);
        this.switchToMain = this.switchToMain.bind(this);
    }

    public render() {
        if (!this.state.isPending && !this.state.error && this.state.response) {
            return <Redirect to={this.state.postLoginTarget} push={false} />
        }

        return (
            <div className="login-root">
                {
                    IS_PRE_RELEASE
                        ? <div className="beta-notice beta-notice-absolute print-hide">
                            <span>This is pre-release software.  You may encounter bugs or unfinished features.</span>
                        </div>
                        : ""
                }
                <div className="login-box info-block info-block-primary">
                    <header className="flex">
                        <h3>User Login</h3>
                        <OverflowMenuItem className="login-header-button">
                            <ToolbarMenuItem condition={!this.state.serverTarget}>
                                <button onClick={this.switchToPlayground}><i className="icon-sign-in" /><span>Log into the Playground</span></button>
                            </ToolbarMenuItem>
                            <ToolbarMenuItem condition={!!this.state.serverTarget}>
                                <button onClick={this.switchToMain}><i className="icon-sign-in" /><span>Log into main system</span></button>
                            </ToolbarMenuItem>
                        </OverflowMenuItem>
                    </header>
                    <p className="login-splash">
                        <img alt="" src={HCWHLogo} />
                    </p>
                    {
                        this.state.serverTarget === "playground"
                            ? <div className="status-box text-small"><b>You are about to log into the playground.</b><br /><br />The playground is a place for learning and testing, without the fear of destroying real patient data.</div>
                            : <p>Log in to access protected information</p>
                    }
                    <form onSubmit={this.processLogin}>
                        <div className="login-inputs">
                            <section>
                                <input type="text" id="login-username" name="username" autoFocus={true} autoCorrect="off" autoCapitalize="none" value={this.state.username} onChange={this.formChanged} disabled={this.state.isPending} alt="Username" placeholder="Username" />
                            </section>
                            <section>
                                <input type="password" id="login-password" name="password" value={this.state.password} onChange={this.formChanged} disabled={this.state.isPending} alt="Password" placeholder="Password" />
                            </section>
                        </div>
                        {
                            (this.state.error && !this.state.isPending) ? (<p className="error-text">{this.state.error}</p>) : ""
                        }
                        {
                            this.state.isPending ? (
                                <div className="lds-dual-ring spinner-center" />
                            ) : (
                                    <div className="button-panel">
                                        <button type="submit" className="button push-right" disabled={this.state.isPending}>Login</button>
                                    </div>
                                )
                        }
                    </form>
                    <div className="version-info">
                        v{VERSION} build {VERSION_BUILD} {IS_PRE_RELEASE ? <span><br />Development Version</span> : ""}
                    </div>
                </div>
                {/*<div className="login-subtext">
                    <span>Unused subtext goes here</span>
                </div>*/}
            </div>
        );
    }

    private formChanged(e: ChangeEvent<HTMLInputElement>) {
        this.setState({
            [e.currentTarget.name]: e.currentTarget.value
        });
    }

    private async processLogin(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();

        this.setState({
            isPending: true,
            response: ""
        });

        try {
            await this.props.authContext.authUser({
                password: this.state.password,
                username: this.state.username.trim(),
                serverTarget: this.state.serverTarget
            });

            this.setState({
                error: undefined,
                isPending: false,
                response: "success"
            })
        }
        catch (e) {
            this.setState({
                error: (e instanceof Error) ? (e as Error).message : "Could not log in, please try again later",
                isPending: false,
            });
        }
    }

    private switchToPlayground() {
        this.setState({
            serverTarget: "playground"
        });
    }

    private switchToMain() {
        this.setState({
            serverTarget: ""
        });
    }
}

export default withAuth(LoginPage);
